import { Fragment, useEffect, useState } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid';
import StopContainerModal from '../../general/modals/StopContainerModal';
import { classNames } from '@/utils/general';
import NotFinishedModal from "@/components/general/modals/NotFinishedModal";
import BlackButton from "@/components/general/buttons/BlackButton";
import { log } from "@/libs/analytics-logging";
import { usePerms } from "@/libs/perms";
import { useRouter } from "next/router";
import { useAuth } from "@/libs/auth";
import { requeryContainerStatus } from "@/services/uptime-store";

export default function ManageContainerButton({ model }: { model: any }) {
  const [containerModal, setContainerModal] = useState(false);
  const [isUsageModal, setUsageModal] = useState(false);
  const router = useRouter();
  const { level } = usePerms();

  const { token } = useAuth()
  const { projectId, modelId } = router.query;

  const isRunning = model?.lifecycleStatus?.running;

  if (level < 5) return null;

  if (!model.deployedVersion) {
    return <BlackButton click={() => {
      router.push(`/${projectId}/${modelId}/versions`);
      log('Deploy Model', { 'location': 'Overview Top Right ' })
    }}>Deploy a Model</BlackButton>;
  }

  return (
    <><Menu as="div" className="relative w-full md:w-auto inline-block text-left mt-2">
      <Menu.Button
        className="border w-full md:w-auto transition ease-in duration-100 rounded-md bg-black hover:bg-gray-800 focus:ring-2 focus:ring-gray-800">
        <div className="my-3 ml-5 mr-3 roboto text-sm text-white">
          Manage Container
          <ChevronDownIcon className="w-4 h-4 inline ml-1" />
        </div>
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            <Menu.Item>
              {({ active }: { active: any }) => (
                <a
                  onClick={() => setUsageModal(true)}
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-black',
                    'block px-4 py-2 text-sm cursor-pointer'
                  )}
                >
                  View Container Usage
                </a>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }: { active: any }) => (
                <a
                  onClick={() => requeryContainerStatus(token, projectId as string, modelId as string)}
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-black',
                    'block px-4 py-2 text-sm cursor-pointer'
                  )}
                >
                  Re-Query Model Status
                </a>
              )}
            </Menu.Item>
            {
              isRunning ? (
                <Menu.Item>
                  {({ active }: { active: any }) => (
                    <a
                      onClick={() => setContainerModal(true)}
                      className={classNames(
                        active ? 'bg-gray-100 text-red-500' : 'text-red-500',
                        'block px-4 py-2 text-sm cursor-pointer'
                      )}
                    >
                      Stop Container
                    </a>
                  )}
                </Menu.Item>
              ) : (
                null
              )
            }


          </div>
        </Menu.Items>
      </Transition>
    </Menu>
      <StopContainerModal open={containerModal} close={() => setContainerModal(false)}
        deployedVersion={model.deployedVersion} />
      <NotFinishedModal open={isUsageModal} close={() => setUsageModal(false)} featureName="usage page"
        type={"feature"} />
    </>
  );
}
